import { createAction, props } from '@ngrx/store';
import { Customer, UserCredentials } from '@models/customer.model';

export enum CustomerActions {
  CREATE_CUSTOMER = '[Customers] Create customer',
  CREATE_CUSTOMER_SUCCESS = '[Customers] Customer created',
  CREATE_CUSTOMER_FAILED = '[Customers] Cannot create customer',
  GET_CUSTOMERS = '[Customers] Get customers',
  GET_CUSTOMERS_SUCCESS = '[Customers] Customers fetched',
  GET_CUSTOMERS_FAILED = '[Customers] Cannot fetch customers',
  UPDATE_CUSTOMER = '[Customers] Update customer',
  UPDATE_CUSTOMER_SUCCESS = '[Customers] Customer updated',
  UPDATE_CUSTOMER_FAILED = '[Customers] Cannot update customer',
  DELETE_CUSTOMER = '[Customers] Delete customer',
  DELETE_CUSTOMER_SUCCESS = '[Customers] Customer deleted',
  DELETE_CUSTOMER_FAILED = '[Customers] Cannot delete customer',
  UPDATE_CUSTOMER_CREDENTIALS = '[Customers] Update customer credentials',
  UPDATE_CUSTOMER_CREDENTIALS_SUCCESS = '[Customers] Customer credentials updated',
  UPDATE_CUSTOMER_CREDENTIALS_FAILED = '[Customers] Cannot update customer credentials',
  GET_ME = '[Customers] Get me',
  GET_ME_SUCCESS = '[Customers] Me fetched',
  GET_ME_FAILED = '[Customers] Cannot fetch me',
  UPDATE_PROFILE = '[Customers] Update profile',
  UPDATE_PROFILE_SUCCESS = '[Customers] Profile updated',
  UPDATE_PROFILE_FAILED = '[Customers] Cannot update profile',
}

export const fetchCustomers = createAction(CustomerActions.GET_CUSTOMERS);
export const customersFetched = createAction(CustomerActions.GET_CUSTOMERS_SUCCESS, props<{ payload: Customer[] }>());
export const cannotFetchCustomers = createAction(CustomerActions.GET_CUSTOMERS_FAILED, props<{ error: string }>());

export const updateCustomer = createAction(CustomerActions.UPDATE_CUSTOMER, props<{ payload: Customer }>());
export const customerUpdated = createAction(CustomerActions.UPDATE_CUSTOMER_SUCCESS, props<{ payload: Customer }>());
export const cannotUpdateCustomer = createAction(CustomerActions.UPDATE_CUSTOMER_FAILED, props<{ error: string }>());

export const createCustomer = createAction(CustomerActions.CREATE_CUSTOMER, props<{ payload: Customer }>());
export const customerCreated = createAction(CustomerActions.CREATE_CUSTOMER_SUCCESS, props<{ payload: Customer }>());
export const cannotCreateCustomer = createAction(CustomerActions.CREATE_CUSTOMER_FAILED, props<{ error: string }>());

export const deleteCustomer = createAction(CustomerActions.DELETE_CUSTOMER, props<{ payload: string }>());
export const customerDeleted = createAction(CustomerActions.DELETE_CUSTOMER_SUCCESS, props<{ payload: string }>());
export const cannotDeleteCustomer = createAction(CustomerActions.DELETE_CUSTOMER_FAILED, props<{ error: string }>());

export const updateCustomerCredentials = createAction(CustomerActions.UPDATE_CUSTOMER_CREDENTIALS, props<{
  payload: UserCredentials
}>());
export const customerCredentialsUpdated = createAction(CustomerActions.UPDATE_CUSTOMER_CREDENTIALS_SUCCESS);
export const cannotUpdateCustomerCredentials = createAction(CustomerActions.UPDATE_CUSTOMER_CREDENTIALS_FAILED, props<{
  error: string
}>());

export const fetchMe = createAction(CustomerActions.GET_ME);
export const meFetched = createAction(CustomerActions.GET_ME_SUCCESS, props<{ payload: Customer }>());
export const cannotFetchMe = createAction(CustomerActions.GET_ME_FAILED, props<{ error: string }>());

export const updateProfile = createAction(CustomerActions.UPDATE_PROFILE, props<{ payload: Customer }>());
export const profileUpdated = createAction(CustomerActions.UPDATE_PROFILE_SUCCESS, props<{ payload: Customer }>());
export const cannotUpdateProfile = createAction(CustomerActions.UPDATE_PROFILE_FAILED, props<{ error: string }>());
